export default __webpack_public_path__ + "static/media/Dhor.d12fdf4c.PNG";